import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06e43723"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ClassRoomAnswerDetailViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "答题详情", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, "状态概览", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, "答题状态", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, "平均正确率", -1));
const _hoisted_7 = {
  class: "ft80",
  style: {
    "color": "#4388FF"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, "平均得分", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, "状态概览", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 0,
  style: {
    "color": "#F56C6C"
  }
};
const _hoisted_14 = {
  key: 1,
  style: {
    "color": "#4388FF"
  }
};
const _hoisted_15 = {
  key: 2,
  style: {
    "color": "#07D3A5"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_PieChart = _resolveComponent("PieChart");
  const _component_ScoreChart = _resolveComponent("ScoreChart");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "flex flex-col wbg mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "pd12"
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _hoisted_4, _createVNode(_component_el_row, {
      class: "flex items-center justify-center",
      style: {
        "padding-bottom": "12px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8,
        class: "flex flex-col flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "flex items-center justify-center pd12 wd100"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12,
            class: "flex items-center"
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12,
            class: "flex justify-end items-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              onClick: $options.init
            }, {
              default: _withCtx(() => [_createTextVNode("刷新")]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }), $data.statistic.state ? (_openBlock(), _createBlock(_component_PieChart, {
          key: 0,
          data: $data.statistic.state
        }, null, 8, ["data"])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8,
        class: "flex flex-col flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "flex items-center justify-center pd12 wd100"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12,
            class: "flex items-center"
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12,
            class: "flex justify-end items-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              onClick: $options.init
            }, {
              default: _withCtx(() => [_createTextVNode("刷新")]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          style: {
            "height": "200px"
          },
          class: "flex items-center justify-center"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString($data.statistic.accuracy.toFixed(2)) + "%", 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8,
        class: "flex flex-col flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "flex items-center justify-center pd12 wd100"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12,
            class: "flex items-center"
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12,
            class: "flex justify-end items-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              size: "small",
              onClick: $options.init
            }, {
              default: _withCtx(() => [_createTextVNode("刷新")]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_ScoreChart, {
          score: $data.statistic.score
        }, null, 8, ["score"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col wbg mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "pd12"
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _hoisted_10, _createVNode(_component_el_row, {
      class: "pd12"
    }, {
      default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
        "table-id": 8,
        ref: "userAnswerTable",
        "init-query": {
          'roomId': $data.roomId,
          'tplId': $data.tplId,
          'state': $data.state
        }
      }, {
        nickName: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data?.user?.nickName), 1)]),
        rightAnswerCnt: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data?.session?.rightAnswerCnt), 1)]),
        wrongAnswerCnt: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data?.session?.wrongAnswerCnt), 1)]),
        accuracy: _withCtx(data => [data.data.session ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(data.data.session.rightAnswerCnt + data.data.session.wrongAnswerCnt > 0 ? (data.data.session.rightAnswerCnt * 100.0 / (data.data.session.rightAnswerCnt + data.data.session.wrongAnswerCnt)).toFixed(2) : '-'), 1)) : _createCommentVNode("", true)]),
        score: _withCtx(data => [data.data.session ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString((data.data.session.rightAnswerCnt / data.data.session.totalQuestion * 100).toFixed(0)), 1)) : _createCommentVNode("", true)]),
        state: _withCtx(data => [!data.data.session ? (_openBlock(), _createElementBlock("span", _hoisted_13, "未开始")) : data.data.session.state == 'TESTING' ? (_openBlock(), _createElementBlock("span", _hoisted_14, "答题中")) : (_openBlock(), _createElementBlock("span", _hoisted_15, "已完成"))]),
        operate: _withCtx(data => [data.data.session && data.data.session?.state != 'TESTING' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "success",
          size: "small",
          onClick: $event => $options.review(data.data.session)
        }, {
          default: _withCtx(() => [_createTextVNode("回看结果 ")]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["init-query"])]),
      _: 1
    })]),
    _: 1
  })]);
}